import { useState, useCallback, useEffect } from 'react';
import useMutationObserver from './useMutationObserver.js';

function useOverflowIndicator(elementRef, enabled = true) {
  const [isOverflowing, setIsOverflowing] = useState(false);
  const updateOverflowStatus = useCallback(() => {
    if (elementRef.current && enabled) {
      setIsOverflowing(elementRef.current.scrollWidth > elementRef.current.clientWidth);
    }
  }, [enabled]);
  useEffect(() => {
    const element = elementRef?.current;
    const resizeObserver = new ResizeObserver(updateOverflowStatus);
    updateOverflowStatus();
    if (enabled) {
      window.addEventListener('resize', updateOverflowStatus);
      if (element) resizeObserver.observe(element);
    }
    return () => {
      if (enabled) {
        window.removeEventListener('resize', updateOverflowStatus);
        if (element) resizeObserver.disconnect();
      }
    };
  }, [enabled]);
  useMutationObserver(elementRef, updateOverflowStatus, {
    enabled,
    subtree: true,
    characterData: true
  });
  return isOverflowing;
}

export { useOverflowIndicator as default };
